import styles from "./styles.module.css";
import { DescriptionProps } from "types/Description.type";

export default function Description({ children, style }: DescriptionProps) {
  return <p className={`${styles.p} ${style || ""}`}>{children}</p>;
}
